import React, { useState } from 'react';
import Container from 'components/Container';
import CoachingView from 'coaching/components/CoachingView';
import CoachingHelp from 'coaching/components/CoachingHelpFormView/CoachingHelp';
import CoachingHelpConfirmation from 'coaching/components/CoachingHelpFormView/CoachingHelpConfirmation';
import {
  GetCoachingHelpForm_me,
  GetCoachingHelpForm_coaching_getCoachingHomeDashboard_participants,
} from 'coaching/queries/__generated__/GetCoachingHelpForm';

export type Props = {
  requester: GetCoachingHelpForm_me | null;
  students?: GetCoachingHelpForm_coaching_getCoachingHomeDashboard_participants[];
  isCoachForm?: boolean;
};

export default function CoachingHelpFormView(props: Props) {
  const [submitSuccessful, setSubmitSuccessful] = useState(false);
  const [contactEmail, setContactEmail] = useState<string | undefined>(undefined);

  const onSubmitSuccess = (contactEmail: string) => {
    setContactEmail(contactEmail);
    setSubmitSuccessful(true);
  };

  const isAuthenticated = !!props.requester;
  const eventPrefix = props.isCoachForm ? 'coaching.coach_help_form' : 'coaching.help_form';

  return (
    <CoachingView headerType={isAuthenticated ? 'help' : 'helpWithLoginButton'}>
      <Container>
        {submitSuccessful ? (
          <CoachingHelpConfirmation
            isCoachForm={props.isCoachForm}
            contactEmail={contactEmail}
            eventPrefix={eventPrefix}
          />
        ) : (
          <CoachingHelp {...props} onSubmitSuccess={onSubmitSuccess} eventPrefix={eventPrefix} />
        )}
      </Container>
    </CoachingView>
  );
}
